/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  SummaryState,
  IntegratedSummary,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  TableSummaryRow,
} from '@devexpress/dx-react-grid-material-ui';
import { downloadCSVFile, getRowId } from '../../common';
import {
  getSalaryitems,
  updateSalaryitem,
  getReportContracts,
  getStartWorks,
  getEndServices,
  getVacations,
} from '../../graphql';
import { useLazyQuery, useMutation } from '@apollo/client';
import _ from 'lodash';
import {
  currencyFormatterEmpty,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { useEmployees, useUsers } from '../../hooks';
import ExportBtn from '../../common/ExportBtn';
import { TableComponent } from '../components/TableComponent';
import HRContext from '../../contexts/hr';
import { getMonthName } from '../../constants/datatypes';
import { moneyFormat } from '../common/formater';
import { SalaryPrint } from '../../print/SalaryPrint';
import { useReactToPrint } from 'react-to-print';
import MyIcon from '../components/MyIcon';
import { sleep, successAlert, errorAlert } from '../../Shared/helpers';
import { SalaryListPrint } from '../../print/SalaryListPrint';
import { SalaryListPrintNew } from '../../print/SalaryListPrintNew';
import EditIcon from '@material-ui/icons/Edit';
import getEmployeeAdvance from '../../graphql/query/getEmployeeAdvance';
import { operationTypes } from '../../constants/datatypes';

export const updateDocTotal = ({ data, isRTL }: any) => {
  const rdata = data.map((d: any) => {
    const month = getMonthName({ num: d?.month, isRTL });
    const { basicSalary, extraSalary, bonos, overtime, deduction } = d;
    const total =
      (basicSalary || 0) +
      (extraSalary || 0) +
      (bonos || 0) +
      (overtime || 0) -
      (deduction || 0);
    return {
      ...d,
      month,
      total,
    };
  });
  return rdata;
};

const MIN_HISTORY_DATE = new Date(2000, 0, 1, 0, 0, 0, 0);

const startOfDay = (value: any) => {
  const dt = new Date(value);
  dt.setHours(0, 0, 0, 0);
  return dt;
};

const endOfDay = (value: any) => {
  const dt = new Date(value);
  dt.setHours(23, 59, 59, 999);
  return dt;
};

const toDate = (value: any) => {
  if (!value) return null;
  const dt = new Date(value);
  return Number.isNaN(dt.getTime()) ? null : dt;
};

const mergeIntervals = (intervals: any[]) => {
  if (!intervals.length) return [];
  const sorted = [...intervals].sort(
    (a, b) => a.start.getTime() - b.start.getTime(),
  );
  const merged = [sorted[0]];
  for (let i = 1; i < sorted.length; i += 1) {
    const current = sorted[i];
    const last = merged[merged.length - 1];
    if (current.start.getTime() <= last.end.getTime()) {
      if (current.end.getTime() > last.end.getTime()) {
        last.end = current.end;
      }
    } else {
      merged.push(current);
    }
  }
  return merged;
};

const subtractOne = (interval: any, blocker: any) => {
  if (
    blocker.end.getTime() < interval.start.getTime() ||
    blocker.start.getTime() > interval.end.getTime()
  ) {
    return [interval];
  }

  const result = [];
  if (blocker.start.getTime() > interval.start.getTime()) {
    result.push({
      start: interval.start,
      end: new Date(blocker.start.getTime() - 1),
    });
  }
  if (blocker.end.getTime() < interval.end.getTime()) {
    result.push({
      start: new Date(blocker.end.getTime() + 1),
      end: interval.end,
    });
  }
  return result;
};

const subtractIntervals = (base: any, blockers: any[]) => {
  let remaining = [base];
  blockers.forEach((blocker) => {
    remaining = remaining.flatMap((interval) => subtractOne(interval, blocker));
  });
  return remaining;
};

const Salaryitems = forwardRef((props: any, ref: any) => {
  const {
    isRTL,
    words,
    start,
    end,
    currentViewNameChange,
    currentViewName,
    company,
    user,
  } = props;

  const selectedDate = start ? new Date(start) : new Date();
  const selectedYear = selectedDate.getFullYear();
  const selectedMonth = selectedDate.getMonth();
  const selectedMonthStart = new Date(
    selectedYear,
    selectedMonth,
    1,
    0,
    0,
    0,
    0,
  );
  const selectedMonthEnd = new Date(
    selectedYear,
    selectedMonth + 1,
    0,
    23,
    59,
    59,
    999,
  );
  const selectedMonthEndExclusive = new Date(
    selectedYear,
    selectedMonth + 1,
    1,
    0,
    0,
    0,
    0,
  );

  const col = getColumns({ isRTL, words });
  const [columns] = useState(
    [
      col.employee,
      { name: 'month', title: isRTL ? 'شهر' : 'Month' },
      { name: 'basicSalary', title: isRTL ? 'الراتب الاساسي' : 'Basic Salary' },
      { name: 'extraSalary', title: isRTL ? 'البدلات' : 'Allowances' },
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'total', title: isRTL ? 'المجموع' : 'Total' },
      { name: 'isPaid', title: isRTL ? 'مدفوع' : 'Paid' },
      { name: 'paymentNo', title: isRTL ? 'مرجع الدفع' : 'Payment Ref' },
      { name: 'edit', title: ' ' },
      { name: 'view', title: ' ' },
    ].filter((x) => x),
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: col.employee.name, width: 250 },
    { columnName: 'month', width: 120 },
    { columnName: 'basicSalary', width: 150 },
    { columnName: 'extraSalary', width: 150 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'bonos', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'total', width: 150 },
    { columnName: 'isPaid', width: 120 },
    { columnName: 'paymentNo', width: 120 },
    { columnName: 'edit', width: 60, align: 'center' },
    { columnName: 'view', width: 80, align: 'center' },
  ]);

  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({
    basicSalary: 0,
    overtime: 0,
    bonos: 0,
    deduction: 0,
    total: 0,
  });
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalLeft, setTotalLeft] = useState(0);
  const [selected, setSelected] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingRow, setEditingRow] = useState<any>(null);
  const [editForm, setEditForm] = useState({
    basicSalary: 0,
    extraSalary: 0,
    overtime: 0,
    bonos: 0,
    deduction: 0,
    desc: '',
  });
  const [__unused, setAlrt] = useState({
    show: false,
    msg: '',
    type: undefined,
  });
  const { users } = useUsers();
  const { employeesfull } = useEmployees();
  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadSalaryitems, opData]: any = useLazyQuery(getSalaryitems, {
    fetchPolicy: 'cache-and-network',
  });

  const [loadContracts, contractsData]: any = useLazyQuery(getReportContracts, {
    fetchPolicy: 'cache-and-network',
  });

  const [loadEmployeeAdvance, advanceData]: any = useLazyQuery(
    getEmployeeAdvance,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const [loadStartWorks, startWorksData]: any = useLazyQuery(getStartWorks, {
    fetchPolicy: 'network-only',
  });

  const [loadEndServices, endServicesData]: any = useLazyQuery(getEndServices, {
    fetchPolicy: 'network-only',
  });

  const [loadVacations, vacationsData]: any = useLazyQuery(getVacations, {
    fetchPolicy: 'network-only',
  });

  const forcingMonthRef = useRef(false);

  const refresQuery = {
    refetchQueries: [
      {
        query: getSalaryitems,
        variables: {
          month: selectedMonth,
          year: selectedYear,
        },
      },
    ],
  };

  const [editSalaryitem] = useMutation(updateSalaryitem, refresQuery);

  useEffect(() => {
    loadSalaryitems({
      variables: {
        month: selectedMonth,
        year: selectedYear,
      },
    });
    loadContracts({
      variables: {
        createtime: true,
        start: selectedMonthStart,
        end: selectedMonthEnd,
      },
    });
    loadEmployeeAdvance({
      variables: {
        start: selectedMonthStart,
        end: selectedMonthEndExclusive,
      },
    });

    loadStartWorks({
      variables: {
        start: MIN_HISTORY_DATE,
        end: selectedMonthEnd,
      },
    });
    loadEndServices({
      variables: {
        start: MIN_HISTORY_DATE,
        end: selectedMonthEnd,
      },
    });
    loadVacations({
      variables: {
        start: selectedMonthStart,
        end: selectedMonthEnd,
      },
    });
  }, [selectedYear, selectedMonth]);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  useEffect(() => {
    if (opData?.data?.getSalaryitems?.data) {
      let { data } = opData.data.getSalaryitems;

      const monthStart = startOfDay(selectedMonthStart);
      const monthEnd = endOfDay(selectedMonthEnd);

      const employeesMap = (employeesfull || []).reduce(
        (acc: any, emp: any) => {
          acc[emp._id] = emp;
          return acc;
        },
        {},
      );

      const startWorks = startWorksData?.data?.getStartWorks?.data || [];
      const endServices = endServicesData?.data?.getEndServices?.data || [];
      const vacations = vacationsData?.data?.getVacations?.data || [];

      const latestRegularStartMap = startWorks.reduce((acc: any, item: any) => {
        if (!item?.employeeId || item?.isVacation === true) return acc;
        const dt = toDate(item?.time);
        if (!dt) return acc;
        if (
          !acc[item.employeeId] ||
          dt.getTime() > new Date(acc[item.employeeId]).getTime()
        ) {
          acc[item.employeeId] = dt;
        }
        return acc;
      }, {});

      const latestEndServiceMap = endServices.reduce((acc: any, item: any) => {
        if (!item?.employeeId) return acc;
        const dt = toDate(item?.time);
        if (!dt) return acc;
        if (
          !acc[item.employeeId] ||
          dt.getTime() > new Date(acc[item.employeeId]).getTime()
        ) {
          acc[item.employeeId] = dt;
        }
        return acc;
      }, {});

      const isEmployeeAvailableForMonth = (employeeId: string) => {
        const employee = employeesMap[employeeId];
        if (!employee) return false;

        const profileStart = toDate(
          employee?.startWorkDate ||
            employee?.enrollmentDate ||
            employee?.startDate,
        );
        const latestRegularStart = toDate(latestRegularStartMap[employeeId]);

        const effectiveStart =
          latestRegularStart || profileStart || new Date(1970, 0, 1);

        const latestEnd = toDate(latestEndServiceMap[employeeId]);
        const profileTermination = toDate(employee?.terminationDate);
        const profileEnd = toDate(employee?.endDate);

        let effectiveEnd = latestEnd;
        [profileTermination, profileEnd].forEach((candidate: any) => {
          if (!candidate) return;
          if (!effectiveEnd || candidate.getTime() > effectiveEnd.getTime()) {
            effectiveEnd = candidate;
          }
        });

        // Re-hire case: latest start is after latest end, so employee is considered active again.
        if (
          effectiveEnd &&
          latestRegularStart &&
          latestRegularStart.getTime() > effectiveEnd.getTime()
        ) {
          effectiveEnd = null;
        }

        if (effectiveEnd && effectiveEnd.getTime() < effectiveStart.getTime()) {
          effectiveEnd = null;
        }

        const activeStart = new Date(
          Math.max(monthStart.getTime(), effectiveStart.getTime()),
        );
        const activeEnd = new Date(
          Math.min(
            monthEnd.getTime(),
            effectiveEnd ? effectiveEnd.getTime() : monthEnd.getTime(),
          ),
        );

        if (activeStart.getTime() > activeEnd.getTime()) {
          return false;
        }

        const vacationIntervals = vacations
          .filter((v: any) => v?.employeeId === employeeId)
          .map((v: any) => {
            const vStart = startOfDay(v?.startDate || v?.time || monthStart);
            const vEnd = endOfDay(v?.endDate || v?.time || monthEnd);
            return {
              start: vStart,
              end: vEnd,
            };
          })
          .filter(
            (v: any) =>
              v.end.getTime() >= activeStart.getTime() &&
              v.start.getTime() <= activeEnd.getTime(),
          )
          .map((v: any) => ({
            start: new Date(Math.max(v.start.getTime(), activeStart.getTime())),
            end: new Date(Math.min(v.end.getTime(), activeEnd.getTime())),
          }));

        if (!vacationIntervals.length) {
          return true;
        }

        const mergedVacations = mergeIntervals(vacationIntervals);
        const remaining = subtractIntervals(
          { start: activeStart, end: activeEnd },
          mergedVacations,
        );

        return remaining.some(
          (interval: any) => interval.end.getTime() >= interval.start.getTime(),
        );
      };

      data = data.filter((d: any) => isEmployeeAvailableForMonth(d.employeeId));
      const rdata = updateDocTotal({ data, isRTL });

      // Enrich with contract commission data
      const contracts = contractsData?.data?.getReportContracts?.data || [];
      const employeeAdvances =
        advanceData?.data?.getEmployeeAdvance?.data || [];
      const advancesByEmployee = employeeAdvances.reduce(
        (acc: any, item: any) => {
          const employeeId = item?.employeeId;
          if (!employeeId) return acc;
          if (!acc[employeeId]) {
            acc[employeeId] = {
              advancePaid: 0,
              advanceReceived: 0,
            };
          }
          const amount = item?.amount || 0;
          if (item?.opType === operationTypes.advancePayemnt) {
            acc[employeeId].advancePaid += amount;
          }
          if (item?.opType === operationTypes.advanceReceipt) {
            acc[employeeId].advanceReceived += amount;
          }
          return acc;
        },
        {},
      );

      const enriched = rdata.map((row: any) => {
        const empl = employeesMap[row.employeeId];
        const comPercent = empl?.comPercent || 0;
        const target = empl?.target || 0;
        const emplContracts = contracts.filter(
          (c: any) => c.employeeId === row.employeeId,
        );
        const totalContractsSales =
          _.sumBy(emplContracts, 'totalinvoiced') || 0;

        let amountSubjectToSales = 0;
        if (!target && !comPercent) {
          amountSubjectToSales = 0;
        } else if (!target && comPercent > 0) {
          amountSubjectToSales = totalContractsSales;
        } else if (target > 0 && comPercent > 0) {
          amountSubjectToSales = Math.max(totalContractsSales - target, 0);
        }

        const salesCommission =
          comPercent > 0 ? (amountSubjectToSales * comPercent) / 100 : 0;
        const employeeAdvance = advancesByEmployee[row.employeeId] || {
          advancePaid: 0,
          advanceReceived: 0,
        };
        const advanceNet =
          (employeeAdvance.advancePaid || 0) -
          (employeeAdvance.advanceReceived || 0);
        return {
          ...row,
          extraSalary: row.extraSalary || 0,
          salesCommissionPercent: comPercent,
          amountSubjectToSales,
          totalContractsSales,
          salesCommission,
          advancePaid: employeeAdvance.advancePaid || 0,
          advanceReceived: employeeAdvance.advanceReceived || 0,
          advancesAndDeductions: advanceNet > 0 ? advanceNet : 0,
        };
      });

      const tp = enriched
        .filter((it: any) => it.isPaid)
        .reduce((sum: number, it: any) => sum + it.total, 0);
      setTotalPaid((prev) => (prev === tp ? prev : tp));
      const tnp = enriched
        .filter((it: any) => !it.isPaid)
        .reduce((sum: number, it: any) => sum + it.total, 0);
      setTotalLeft((prev) => (prev === tnp ? prev : tnp));
      const totals = {
        basicSalary: enriched.reduce(
          (acc: number, item: any) => acc + item.basicSalary,
          0,
        ),
        overtime: enriched.reduce(
          (acc: number, item: any) => acc + item.overtime,
          0,
        ),
        bonos: enriched.reduce((acc: number, item: any) => acc + item.bonos, 0),
        deduction: enriched.reduce(
          (acc: number, item: any) => acc + item.deduction,
          0,
        ),
        total: enriched.reduce((acc: number, item: any) => acc + item.total, 0),
      };
      setRows((prev: any) => (_.isEqual(prev, enriched) ? prev : enriched));
      setTotals((prev: any) => (_.isEqual(prev, totals) ? prev : totals));
    }
  }, [
    opData,
    contractsData,
    advanceData,
    startWorksData,
    endServicesData,
    vacationsData,
    employeesfull,
    isRTL,
    selectedYear,
    selectedMonth,
  ]);
  useEffect(() => {
    if (currentViewName === 'Month') {
      forcingMonthRef.current = false;
      return;
    }

    // Prevent dispatch loops if another control keeps bouncing the view name.
    if (forcingMonthRef.current) {
      return;
    }

    forcingMonthRef.current = true;
    currentViewNameChange({ target: { value: 'Month' } });
  }, [currentViewName, currentViewNameChange]);

  const downloadCSVSubmit = () => {
    const colnames = columns?.map((col: any) => col?.name);
    downloadCSVFile(rows, 'Salary', colnames);
  };

  const handleOpenEditDialog = (row: any) => {
    setEditingRow(row);
    setEditForm({
      basicSalary: row.basicSalary || 0,
      extraSalary: row.extraSalary || 0,
      overtime: row.overtime || 0,
      bonos: row.bonos || 0,
      deduction: row.deduction || 0,
      desc: row.desc || '',
    });
    setEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setEditingRow(null);
  };

  const handleSaveEdit = async () => {
    if (!editingRow) return;
    try {
      const res = await editSalaryitem({
        variables: {
          _id: editingRow._id,
          ...editForm,
        },
      });
      if (res?.data?.updateSalaryitem?.ok) {
        successAlert(setAlrt, isRTL);
        handleCloseEditDialog();
      } else {
        errorAlert(setAlrt, isRTL);
      }
    } catch (error) {
      console.log(error);
      errorAlert(setAlrt, isRTL);
    }
  };

  const totalSummaryItems = [
    { columnName: 'basicSalary', type: 'sum' },
    { columnName: 'extraSalary', type: 'sum' },
    { columnName: 'bonos', type: 'sum' },
    { columnName: 'overtime', type: 'sum' },
    { columnName: 'deduction', type: 'sum' },
    { columnName: 'total', type: 'sum' },
  ];

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Salary`,
    removeAfterPrint: true,
  });

  const newcomponentRef: any = useRef();
  const newhandleReactPrint = useReactToPrint({
    content: () => newcomponentRef.current,
    documentTitle: `Salary List`,
    removeAfterPrint: true,
  });

  const landscapeComponentRef: any = useRef();
  const landscapehandleReactPrint = useReactToPrint({
    content: () => landscapeComponentRef.current,
    documentTitle: `Salary List Landscape`,
    removeAfterPrint: true,
  });
  const newprintData = {
    rows,
    totals,
    isRTL,
    start,
    end,
  };

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 8,
          left: isRTL ? 250 : undefined,
          right: isRTL ? undefined : 250,
          display: 'flex',
        }}
      >
        <Button
          onClick={landscapehandleReactPrint}
          variant="contained"
          color="secondary"
          style={{
            minWidth: 100,
            marginLeft: 10,
            marginRight: 10,
            height: 35,
          }}
        >
          <Typography>{isRTL ? 'طباعة عرضية' : 'Landscape Print'}</Typography>
        </Button>
        <Button
          onClick={newhandleReactPrint}
          variant="contained"
          color="primary"
          style={{
            minWidth: 100,
            marginLeft: 10,
            marginRight: 10,
            height: 35,
          }}
        >
          <Typography>{isRTL ? 'طباعة' : 'Print'}</Typography>
        </Button>
        <ExportBtn open={downloadCSVSubmit} isRTL={isRTL}></ExportBtn>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <SummaryState totalItems={totalSummaryItems} />
        <IntegratedSummary />

        <SearchState />
        <IntegratedSorting />
        <IntegratedFiltering />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 40 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            col.employee.name,
            'month',
            'basicSalary',
            'extraSalary',
            'overtime',
            'bonos',
            'deduction',
            'total',
            'isPaid',
            'paymentNo',
            'edit',
            'view',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['isPaid']}
          formatterComponent={({ value }: any) => {
            return value ? (
              <span
                style={{
                  padding: 5,
                  color: '#25D366',
                  fontSize: 18,
                  fontWeight: 'bold',
                }}
              >
                ✔
              </span>
            ) : (
              <></>
            );
          }}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['view']}
          formatterComponent={({ row }: any) => {
            return (
              <IconButton
                style={{ height: 40 }}
                onClick={async () => {
                  setSelected(row);
                  await sleep(0.25);
                  handleReactPrint();
                }}
              >
                <MyIcon size={22} icon="print"></MyIcon>
              </IconButton>
            );
          }}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['edit']}
          formatterComponent={({ row }: any) => {
            // Only show edit button if not paid
            if (row.isPaid) return <></>;
            return (
              <IconButton
                style={{ height: 40 }}
                onClick={() => handleOpenEditDialog(row)}
                title={isRTL ? 'تعديل' : 'Edit'}
              >
                <EditIcon style={{ fontSize: 20 }} />
              </IconButton>
            );
          }}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={[
            'overtime',
            'bonos',
            'deduction',
            'basicSalary',
            'extraSalary',
            'total',
          ]}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <TableSummaryRow
          messages={{
            sum: isRTL ? 'المجموع' : 'Total',
          }}
        ></TableSummaryRow>
      </Grid>
      <Box
        style={{
          position: 'absolute',
          top: 70,
          left: 500,
          display: 'flex',
          minWidth: 400,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography style={{ fontWeight: 'bold' }}>
          {isRTL ? 'مجموع المدفوع' : 'Total Paid'} {moneyFormat(totalPaid)}
        </Typography>
        <Typography style={{ fontWeight: 'bold' }}>
          {isRTL ? 'مجموع المتبقي' : 'Total Remaining'} {moneyFormat(totalLeft)}
        </Typography>
      </Box>
      <div style={{ display: 'none' }}>
        <SalaryPrint
          company={company}
          user={user}
          printData={selected}
          isRTL={isRTL}
          ref={componentRef}
        />
      </div>
      <div style={{ display: 'none' }}>
        <SalaryListPrint
          company={company}
          printData={newprintData}
          ref={newcomponentRef}
        />
      </div>
      <div style={{ display: 'none' }}>
        <SalaryListPrintNew
          company={company}
          printData={newprintData}
          ref={landscapeComponentRef}
        />
      </div>

      {/* Edit Salary Item Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {isRTL ? 'تعديل بند الراتب' : 'Edit Salary Item'}
          {editingRow && (
            <Typography variant="subtitle2" color="textSecondary">
              {isRTL ? editingRow?.employeeNameAr : editingRow?.employeeName}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            style={{ gap: 16, marginTop: 8 }}
          >
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label={isRTL ? 'الراتب الاساسي' : 'Basic Salary'}
              value={editForm.basicSalary}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  basicSalary: Number(e.target.value),
                })
              }
            />
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label={isRTL ? 'البدلات' : 'Allowances'}
              value={editForm.extraSalary}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  extraSalary: Number(e.target.value),
                })
              }
            />
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label={isRTL ? 'اضافي' : 'Overtime'}
              value={editForm.overtime}
              onChange={(e) =>
                setEditForm({ ...editForm, overtime: Number(e.target.value) })
              }
            />
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label={isRTL ? 'مكافئة' : 'Bonos'}
              value={editForm.bonos}
              onChange={(e) =>
                setEditForm({ ...editForm, bonos: Number(e.target.value) })
              }
            />
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              label={isRTL ? 'خصم' : 'Deduction'}
              value={editForm.deduction}
              onChange={(e) =>
                setEditForm({ ...editForm, deduction: Number(e.target.value) })
              }
            />
            <TextField
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              label={isRTL ? 'ملاحظات' : 'Description'}
              value={editForm.desc}
              onChange={(e) =>
                setEditForm({ ...editForm, desc: e.target.value })
              }
            />
            <Box
              style={{
                backgroundColor: '#f5f5f5',
                padding: 12,
                borderRadius: 8,
                marginTop: 8,
              }}
            >
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                {isRTL ? 'المجموع: ' : 'Total: '}
                {moneyFormat(
                  (editForm.basicSalary || 0) +
                    (editForm.extraSalary || 0) +
                    (editForm.overtime || 0) +
                    (editForm.bonos || 0) -
                    (editForm.deduction || 0),
                )}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="primary">
            {isRTL ? 'إلغاء' : 'Cancel'}
          </Button>
          <Button onClick={handleSaveEdit} color="primary" variant="contained">
            {isRTL ? 'حفظ' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default Salaryitems;
